import { render } from "./MediaField.vue?vue&type=template&id=c81376e6"
import script from "./MediaField.vue?vue&type=script&lang=js"
export * from "./MediaField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__